import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/loading.svg'
import _imports_1 from '@/assets/images/affirm-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-27afab0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center","width":"100%","margin":"0 auto"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"max-width":"100px","margin":"10vh auto"}
  })
], -1))
const _hoisted_3 = {
  class: "column is-one-third",
  style: {"display":"none"}
}
const _hoisted_4 = {
  key: 0,
  class: "amount"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Amount due:", -1))
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Paid:", -1))
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = {
  key: 2,
  class: "amount"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Outstanding due:", -1))
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = {
  key: 3,
  class: "amount"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ph mb-3" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 ph" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 4,
  class: "amount-received is-block has-text-centered mt-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Pay via Wire Transfer")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Pay Outstanding")
const _hoisted_20 = {
  key: 7,
  class: "button is-success is-centered begin paid"
}
const _hoisted_21 = {
  key: 8,
  class: "button wire is-info is-centered begin ph",
  type: "button"
}
const _hoisted_22 = {
  key: 9,
  class: "center-text"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Pay over time", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 11,
  class: "affirm-help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.invoice.uuid && !_ctx.isPaid && !_ctx.isPartiallyPaid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.currency(_ctx.invoice.total_price, _ctx.invoice.currency, 2, true)), 1)
          ]))
        : (_ctx.invoice.uuid && _ctx.isPaid)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["amount", { paid: _ctx.isPaid }])
            }, [
              _hoisted_7,
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.currency(_ctx.invoice.total_price, _ctx.invoice.currency, 2, true)), 1)
            ], 2))
          : (_ctx.invoice.uuid && _ctx.isPartiallyPaid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.currency(_ctx.invoice.outstanding_amount, _ctx.invoice.currency, 2, true)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)),
      (_ctx.isPartiallyPaid && _ctx.amountReceived)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("small", null, "Received: " + _toDisplayString(_ctx.currency(_ctx.amountReceived, _ctx.invoice.currency, 2, true)), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_17,
      (_ctx.invoice.uuid && !_ctx.isPaid && !_ctx.isPartiallyPaid && _ctx.wireMethod)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 5,
            class: "button wire is-info is-centered begin",
            to: { name: 'InvoiceWireInfo' }
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }))
        : (_ctx.invoice.uuid && _ctx.isPartiallyPaid && _ctx.wireMethod)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 6,
              class: "button is-warning is-centered begin",
              to: { name: 'InvoiceWireInfo' }
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }))
          : (_ctx.isPaid && _ctx.wireMethod)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "PAID"))
            : (_ctx.wireMethod)
              ? (_openBlock(), _createElementBlock("button", _hoisted_21))
              : _createCommentVNode("", true),
      (_ctx.invoice.uuid && _ctx.affirmMethod && _ctx.wireMethod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " or "))
        : _createCommentVNode("", true),
      (_ctx.invoice.uuid && _ctx.affirmMethod && !_ctx.isPaid)
        ? (_openBlock(), _createElementBlock("button", {
            key: 10,
            class: "button affirm is-centered begin",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkout && _ctx.checkout(...args)))
          }, _hoisted_25))
        : _createCommentVNode("", true),
      (_ctx.invoice.uuid && _ctx.affirmMethod && !_ctx.isPaid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Make 4 interest-free payments with zero fees. Prequalify now "))
        : _createCommentVNode("", true)
    ])
  ]))
}